/* Model */
class PasswordPolicyModel extends App.Models.BaseModel {
    modelUrl = 'PasswordPolicy';
}

App.Models.PasswordPolicy = PasswordPolicyModel;

/* Collection */
class PasswordPolicyCollection extends App.Collections.BaseCollection {
    url = 'PasswordPolicy';
    model = App.Models.PasswordPolicy;
}

App.Collections.PasswordPolicys = PasswordPolicyCollection;

/* Router */
class PasswordPolicyRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'PasswordPolicy';
        const model = App.Models.PasswordPolicy;
        const collectionClass = App.Collections.PasswordPolicys;

        super(entityName, model, collectionClass);
	}

	afterCreateForm = (entity, formData, crudStage) => {
    const passwordPolicyFields = App.Forms.PasswordPolicy.form.fields;
    const { organization , group } = passwordPolicyFields;

    const radioOrganizationElement = document.createElement('input');
    const radioGroupElement = document.createElement('input');
    radioOrganizationElement.type = 'radio';
    radioGroupElement.type = 'radio';
    
    let label = organization.rootEl.querySelector("label");
    label.insertBefore(radioOrganizationElement, label.firstChild);
    label = group.rootEl.querySelector("label");
    label.insertBefore(radioGroupElement, label.firstChild);

        if (crudStage === 'new') {
            radioOrganizationElement.checked = true;
            organization.setMandatory(true);
            group.disable();
        }

    radioOrganizationElement.addEventListener('change', function () {
        if (this.checked) {
            organization.setMandatory(true);
            group.setMandatory(false);
            radioGroupElement.checked = false;
            organization.enable();
            group.clear();
            group.disable();
        }
    });

    radioGroupElement.addEventListener('change', function () {
        if (this.checked) {
            organization.setMandatory(false);
            group.setMandatory(true);
            radioOrganizationElement.checked = false;
            group.enable();
            organization.clear();
            organization.disable();
        }
    });
}
	afterPopulateForm = (model) => {
		const passwordPolicyFields = App.Forms.PasswordPolicy.form.fields;
		const { organization , group } = passwordPolicyFields;
	
		const organizationValue = organization.value.description;
		const groupValue = group.value.description;
		
		const radioGroupElement = document.querySelector('#PasswordPolicy_group > label > input[type=radio]');
		const radioOrganizationElement = document.querySelector('#PasswordPolicy_organization > label > input[type=radio]');
	
        
        if (groupValue) {
            organization.disable();
			group.setMandatory(true);
			radioGroupElement.checked = true;
		} else if (organizationValue) {
			group.disable();
			radioOrganizationElement.checked = true;
		    organization.setMandatory(true);
		}
	}
}

App.Routers.PasswordPolicy = PasswordPolicyRouter;
